module.exports = __webpack_public_path__ + "static/media/cinasearch.aaede29d.jpg";